import React, { type FC, type PropsWithChildren } from 'react';

import Icon, { type IconTypes } from '../icon/icon';
import Box from '../box/box';
import Link, { type LinkProps } from '../link/link';

export interface ControlButtonProps extends LinkProps {
  /** Determines the icon to render within the button */
  iconType: IconTypes;
  /** Determines if the button has a dark background */
  hasDarkBackground?: boolean;
}

const ControlButton: FC<PropsWithChildren<ControlButtonProps>> = ({ iconType, hasDarkBackground, ...rest }) => (
  <Link
    {...rest}
    asButton
    css={[
      {
        padding: 0,
        label: 'controlButton',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '32px',
        height: '32px',
        '&:hover, &:focus': {
          '&:not([disabled])': {
            outline: 'none',
            '&::before': {
              display: 'none',
            },
            '&:focus-visible': {
              '&::before': {
                display: 'block',
              },
            },
          },
        },
      },
    ]}
    variant={hasDarkBackground ? 'secondary' : 'primary'}
  >
    <Box
      css={[
        { '& span': { display: 'flex', alignItems: 'center' } },
        iconType === 'PlayOutline' && {
          transform: 'translateX(2px)',
        },
      ]}
    >
      <Icon type={iconType} />
    </Box>
  </Link>
);

export default ControlButton;
